import QtdModulo from '../../ModulosCrefito/QtdModulo'
import TOregistroProntuario from '../../ModulosCrefito/ModulosTO/TOregistroProntuario'
import TOestagio from '../../ModulosCrefito/ModulosTO/TOestagio'
import TOoutrosDados from '../../ModulosCrefito/ModulosTO/TOoutrosDados'
import TOorientacoes from '../../ModulosCrefito/ModulosTO/TOorientacoes'
import TOresponsavelFisc from '../../ModulosCrefito/ModulosTO/TOresponsavelFisc'
import TOprofissionaisNoEstabelecimento from '../../ModulosCrefito/ModulosTO/TOprofissionaisNoEstabelecimento'
import TOparametrosAssistenciais from '../../ModulosCrefito/ModulosTO/TOparametrosAssistenciais'
import TOnasfModalidades from '../../ModulosCrefito/ModulosTO/TOnafsModalidade'
import TOnasfMunicipio from '../../ModulosCrefito/ModulosTO/TOnasfMunicipio'
import TOepi from '../../ModulosCrefito/ModulosTO/TOepi'
import Terceirizados from '../../ModulosCrefito/Modulos/Terceirizados'
import Fiscalizadores from '../../ModulosCrefito/Modulos/Fiscalizadores'
import React from 'react'

const Nasf = () => {
    return (
        <>
            <Fiscalizadores modulo="fiscalizadores" />
            <QtdModulo texto="SERVIÇOS TERCEIRIZADOS" modulo="terceirizados" />
            <Terceirizados modulo="terceirizados" />
            <QtdModulo texto="MODALIDADE DE NASF-AB" modulo="tonasfmodalidade" />
            <TOnasfModalidades modulo="tonasfmodalidade" />
            <QtdModulo texto="RESPONSÁVEL PELO RECEBIMENTO DA FISCALIZAÇÃO" modulo="toresponsavelfisc" />
            <TOresponsavelFisc modulo="toresponsavelfisc" />
            <QtdModulo texto="PROFISSIONAIS TERAPEUTAS OCUPACIONAIS" modulo="toprofissionaisnoestabelecimento" />
            <TOprofissionaisNoEstabelecimento modulo="toprofissionaisnoestabelecimento" />
            <QtdModulo texto="SOBRE A ATUAÇÃO DO NASF NO MUNICÍPIO" modulo="tonasfmunicipio" />
            <TOnasfMunicipio modulo="tonasfmunicipio" />
            <QtdModulo texto="PARÂMETROS ASSISTENCIAIS" modulo="toparametrosassistenciais" />
            <TOparametrosAssistenciais modulo="toparametrosassistenciais" />
            <QtdModulo texto="REGISTRO EM PRONTUÁRIO" modulo="toregistroprontuario" />
            <TOregistroProntuario modulo="toregistroprontuario" />
            <QtdModulo texto="ESTÁGIO" modulo="toestagio" />
            <TOestagio modulo="toestagio" />
            <QtdModulo texto="EPI" modulo="toepi" />
            <TOepi modulo="toepi" />
            <QtdModulo texto="OUTROS DADOS DA FISCALIZAÇÃO" modulo="tooutrosDados" />
            <TOoutrosDados modulo="tooutrosDados" />
            <QtdModulo texto="ORIENTAÇÕES/RECOMENDAÇÕES/NOTIFICAÇÕES" modulo="toorientacoes" />
            <TOorientacoes modulo="toorientacoes" />
        </>
    )
}

export default Nasf